import { PackageStatus, PackageStatusSchema } from '@/models'

export const statusLabels: Record<PackageStatus, string> = {
  [PackageStatusSchema.enum.Archived]: 'Archived',
  [PackageStatusSchema.enum.Pending]: 'Pending',
  [PackageStatusSchema.enum.Received]: 'Received',
  [PackageStatusSchema.enum.Requested]: 'Requested',
}
